(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  function cmToIn(cm) {
    return cm * 0.3937007874;
  }

  ready(function () {
    var modal = document.getElementById("sizechart-modal");
    if (!modal) return;

    // Persist unit + size across pages
    var savedUnit = localStorage.getItem("tg_size_unit") || "cm";
    var savedVariantId = localStorage.getItem("tg_size_variant_id") || "";

    // Elements
    var accToggle = document.getElementById("sg-accordion-toggle");
    var accPanel = document.getElementById("sg-accordion-panel");
    var accInner = accPanel ? accPanel.querySelector(".sg-accordion-inner") : null;

    var grid = document.getElementById("size-button-grid");
    var variantInput = document.getElementById("subscription-variant-id");
    var form = document.getElementById("subscription-checkout-form");
    var submitBtn = document.getElementById("subscription-submit");

    // Ensure closed on load
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    // =========================
    // Mobile helper
    // =========================
    function isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    }

    // =========================
    // Slow scroll
    // =========================
    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animateScrollTop(container, targetTop, duration) {
      if (!container) return;

      var startTop = container.scrollTop;
      var delta = targetTop - startTop;
      var startTime = null;

      if (container._tgScrollRAF) cancelAnimationFrame(container._tgScrollRAF);

      function step(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min(1, (ts - startTime) / duration);
        var eased = easeInOutCubic(p);
        container.scrollTop = startTop + delta * eased;
        if (p < 1) container._tgScrollRAF = requestAnimationFrame(step);
      }

      container._tgScrollRAF = requestAnimationFrame(step);
    }

    function slowRevealScroll(el, offset, duration) {
      if (!el) return;
      offset = offset || 90;
      duration = duration || 2000;

      if (isMobile()) {
        var mRect = modal.getBoundingClientRect();
        var eRect = el.getBoundingClientRect();
        var delta = eRect.top - mRect.top - offset;
        animateScrollTop(modal, modal.scrollTop + delta, duration);
        return;
      }

      var body = modal.querySelector(".sizechart-body");
      if (!body) return;

      var bRect = body.getBoundingClientRect();
      var eRect2 = el.getBoundingClientRect();
      var delta2 = eRect2.top - bRect.top - offset;

      animateScrollTop(body, body.scrollTop + delta2, duration);
    }

    // =========================
    // Lock page behind (mobile only)
    // =========================
    var lastScrollY = 0;
    function lockPage() {
      if (!isMobile()) return;
      lastScrollY = window.scrollY || 0;
      document.documentElement.classList.add("tg-lock");
      document.body.classList.add("tg-lock");
      document.body.style.top = -lastScrollY + "px";
    }
    function unlockPage() {
      document.documentElement.classList.remove("tg-lock");
      document.body.classList.remove("tg-lock");
      var top = document.body.style.top;
      document.body.style.top = "";
      if (top) {
        var y = Math.abs(parseInt(top, 10)) || 0;
        window.scrollTo(0, y);
      }
    }

    // =========================
    // Units (CM / INCH)
    // =========================
    function renderUnit(unit) {
      savedUnit = unit;
      localStorage.setItem("tg_size_unit", unit);

      modal.querySelectorAll("[data-cm]").forEach(function (cell) {
        var cm = Number(cell.getAttribute("data-cm"));
        cell.textContent = unit === "cm" ? cm : Math.round(cmToIn(cm));
      });

      modal.querySelectorAll(".sg-pill").forEach(function (btn) {
        var active = btn.getAttribute("data-unit") === unit;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });

      var deviationEl = document.getElementById("sg-deviation");
      if (deviationEl) {
        deviationEl.textContent =
          unit === "cm" ? "Deviation ± 1.5 cm" : "Deviation ± 0.6 inches";
      }
    }

    // =========================
    // Size restore/apply helpers
    // =========================
    function applySelectedVariant(variantId) {
      if (!grid || !variantInput || !submitBtn) return;

      var btn = grid.querySelector(
        '.size-button[data-variant-id="' + variantId + '"]'
      );
      if (!btn) return;

      grid
        .querySelectorAll(".size-button")
        .forEach(function (b) {
          b.classList.remove("size-button--active");
        });

      btn.classList.add("size-button--active");
      variantInput.value = variantId;

      submitBtn.disabled = false;
      submitBtn.classList.add("active-checkout-button");
    }

    // =========================
    // Accordion (height animation)
    // =========================
    function hardCloseAccordion() {
      if (!accToggle || !accPanel) return;
      accToggle.setAttribute("aria-expanded", "false");
      accPanel.dataset.state = "closed";
      accPanel.setAttribute("aria-hidden", "true");
      accPanel.style.height = "0px";
    }

    function openAccordion() {
      if (!accToggle || !accPanel || !accInner) return;

      accToggle.setAttribute("aria-expanded", "true");
      accPanel.dataset.state = "open";
      accPanel.setAttribute("aria-hidden", "false");

      renderUnit(savedUnit);

      accPanel.style.height = "0px";

      requestAnimationFrame(function () {
        accPanel.getBoundingClientRect();

        var targetHeight = accInner.scrollHeight;
        accPanel.style.height = targetHeight + "px";

        slowRevealScroll(accPanel, 90, 2200);
      });

      var onEnd = function (e) {
        if (e.propertyName !== "height") return;
        accPanel.removeEventListener("transitionend", onEnd);
        if (accPanel.dataset.state === "open") accPanel.style.height = "auto";
      };
      accPanel.addEventListener("transitionend", onEnd);

      accPanel.querySelectorAll("img").forEach(function (img) {
        if (img.complete) return;
        img.addEventListener(
          "load",
          function () {
            if (accPanel.dataset.state === "open" && accPanel.style.height !== "auto") {
              accPanel.style.height = accInner.scrollHeight + "px";
            }
          },
          { once: true }
        );
      });
    }

    function closeAccordion() {
      if (!accToggle || !accPanel || !accInner) return;

      accToggle.setAttribute("aria-expanded", "false");
      accPanel.dataset.state = "closed";
      accPanel.setAttribute("aria-hidden", "true");

      var current = accPanel.offsetHeight;
      accPanel.style.height = current + "px";
      accPanel.getBoundingClientRect();
      accPanel.style.height = "0px";
    }

    hardCloseAccordion();

    if (accToggle && accPanel) {
      accToggle.addEventListener("click", function (e) {
        e.preventDefault();
        var isOpen = accPanel.dataset.state === "open";
        if (isOpen) closeAccordion();
        else openAccordion();
      });
    }

    // =========================
    // Modal open/close
    // =========================
    function openModal() {
      if (modal.classList.contains("is-open")) return;

      renderUnit(savedUnit);
      closeAccordion();

      // RESTORE SAVED SIZE ON EVERY OPEN
      if (savedVariantId) {
        applySelectedVariant(savedVariantId);
      }

      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");

      lockPage();

      if (isMobile()) {
        modal.scrollTop = 0;
      } else {
        var body = modal.querySelector(".sizechart-body");
        if (body) body.scrollTop = 0;
      }
    }

    function closeModal() {
      closeAccordion();
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      unlockPage();
    }

    // Open button(s) anywhere on page
    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-sizechart-open]");
      if (!openBtn) return;
      e.preventDefault();
      openModal();
    });

    // Inside modal clicks
    modal.addEventListener("click", function (e) {
      // Unit buttons
      var unitBtn = e.target.closest(".sg-pill");
      if (unitBtn) {
        e.preventDefault();
        renderUnit(unitBtn.getAttribute("data-unit"));
        if (
          accPanel &&
          accPanel.dataset.state === "open" &&
          accInner &&
          accPanel.style.height !== "auto"
        ) {
          accPanel.style.height = accInner.scrollHeight + "px";
        }
        return;
      }

      // Close on X or overlay
      if (e.target.closest("[data-sizechart-close]")) {
        e.preventDefault();
        closeModal();
        return;
      }

      // Desktop: overlay click closes
      if (!isMobile()) {
        var insideDialog = !!e.target.closest(".sizechart-dialog");
        if (!insideDialog) {
          e.preventDefault();
          closeModal();
        }
      }
    });

    // ESC close
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
    });

    // =========================
    // Size selection + checkout
    // =========================
    if (grid && variantInput && form && submitBtn) {
      var sizeButtons = grid.querySelectorAll(".size-button");

      sizeButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var variantId = btn.getAttribute("data-variant-id");
          var isActive = btn.classList.contains("size-button--active");

          // click again to unselect (TEMPORARY only — keep savedVariantId)
          if (isActive) {
            btn.classList.remove("size-button--active");
            variantInput.value = "";
            submitBtn.disabled = true;
            submitBtn.classList.remove("active-checkout-button");
            return;
          }

          sizeButtons.forEach(function (b) {
            b.classList.remove("size-button--active");
          });
          btn.classList.add("size-button--active");

          variantInput.value = variantId;
          submitBtn.disabled = false;
          submitBtn.classList.add("active-checkout-button");

          // SAVE selection for other pages
          savedVariantId = variantId;
          localStorage.setItem("tg_size_variant_id", variantId);
        });
      });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var variantId = variantInput.value;
        if (!variantId) return;

        fetch("/cart/clear.js", { method: "POST" })
          .then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                    selling_plan: 690077270347,
                  },
                ],
              }),
            });
          })
          .then(function () {
            window.location.href = "/checkout";
          })
          .catch(function (err) {
            console.error(err);
            alert("Something went wrong. Try again.");
          });
      });
    }

    // Initial render
    renderUnit(savedUnit);

    // Also restore size on load (so it’s ready before first open)
    if (savedVariantId) applySelectedVariant(savedVariantId);
  });
})();

